export default __webpack_public_path__ + "panton_green-479d4d56421752beaf8a84589ecdc58e.xml";